/*
 * @Author       : 程哲林
 * @Date         : 2021-12-03 10:53:09
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-09-14 13:45:06
 * @FilePath     : /marketing-introduce-ssr/components/Activity/ActionSheet/index.tsx
 * @Description  : 未添加文件描述
 */
// import React from 'react'
import ReactDOM from 'react-dom';

class ActionSheet {
  static showInstance(Comp: JSX.Element, key?: string) {
    const domKey = key || `as_${Math.floor(Math.random() * 100000).toString()}`;

    this.removeInstance(domKey);
    if (!document.getElementById(domKey)) {
      // const props = properties || {}
      const div = document.createElement('div');
      div.setAttribute('id', domKey);
      document.body.appendChild(div);
      ReactDOM.render(Comp, div);
    }

    return domKey;
  }

  static removeInstance(key: string) {
    const el = document.getElementById(key);
    if (el) {
      const unmountResult = ReactDOM.unmountComponentAtNode(el);
      if (unmountResult && el.parentNode) {
        el.parentNode.removeChild(el);
      }
      el?.remove();
    }
  }
}

/* const ActionSheetComp = React.memo(
  ({ children, onClose }: IProps): JSX.Element | null => {
    return (
      <div className={styles.ac}>
        <div className={styles.ct}>
          <i
            onClick={(e: React.UIEvent) => {
              e.preventDefault()
              if (typeof onClose === 'function') {
                onClose()
              } else {
                ActionSheet.removeInstance()
              }
            }}
            className={cx('ui-icon', 'ui-icon__img18', styles.close)}
          ></i>
          {children}
        </div>
      </div>
    )
  }
) */

export { ActionSheet };
